var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnableEncryptionIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.8287 2.34286L5.60477 4.67401C4.41656 5.12666 3.44336 6.52988 3.44336 7.80862V16.9748C3.44336 17.8914 4.04312 19.1023 4.77868 19.6455L11.0026 24.2965C12.1003 25.1225 13.8996 25.1225 14.9973 24.2965L21.2212 19.6455C21.9568 19.091 22.5566 17.8914 22.5566 16.9748V7.80862C22.5566 6.5412 21.5834 5.12666 20.3952 4.68533L14.1712 2.35417C13.5375 2.10522 12.4738 2.10522 11.8287 2.34286Z",
    fill: "#0A5AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6503 11.2942V10.5836C16.6503 9.67843 16.6503 6.93359 13.0003 6.93359C9.35023 6.93359 9.35023 9.67843 9.35023 10.5836V11.2942C8.16275 11.557 7.76367 12.3259 7.76367 13.9903V14.9637C7.76367 17.105 8.42555 17.7669 10.5669 17.7669H15.4336C17.575 17.7669 18.2369 17.105 18.2369 14.9637V13.9903C18.2369 12.3259 17.8378 11.557 16.6503 11.2942ZM15.1903 11.1871H10.8102V10.5836C10.8102 9.16255 11.1607 8.39361 13.0003 8.39361C14.8399 8.39361 15.1903 9.16255 15.1903 10.5836V11.1871Z",
    fill: "#0A5AF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnableEncryptionIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/enable-encryption-icon.1c88d1b73b7b2710eccf2cdb77fe2986.svg";